import Route from '@ember/routing/route';
import { set } from '@ember/object';
import { service } from '@ember/service';

export default class ContactGiftsByPledgeRoute extends Route {
  @service fundsService;
  @service navbarSettings;
  @service store;

  beforeModel() {
    set(this, 'navbarSettings.title', 'Gifts by Pledge');
    return this.fundsService.confirmValidFundToken();
  }

  async model() {
    let { contact } = this.modelFor('funds.fund.contacts.contact');
    let pledges = (
      await this.store.query('pledge', { filter: { contact_id: contact.id } })
    ).slice();
    let lines = (
      await this.store.query('line-item', {
        filter: { contact_id: contact.id },
      })
    ).slice();

    let pledgesById = {};
    pledges.forEach((pledge) => {
      pledgesById[pledge.id] = pledge;
    });

    let items = lines.map((line) => {
      return {
        line,
        pledge: pledgesById[line.pledgeId],
      };
    });

    return {
      contact,
      items,
    };
  }
}
